import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PaceOfflineFeatureState } from '../store/state';

export interface OfflineStrategy {
    getState(): Observable<PaceOfflineFeatureState | undefined>;
    setState(state: PaceOfflineFeatureState): Observable<boolean>;
    deleteCache(): Observable<boolean>;
    /**
     *
     * Checks if there are any entries using legacy encryption format.
     *
     * This method queries the collection of stored entries and determines whether
     * any entry's content starts with the legacy encryption prefix.
     *
     * This method is only relevant for the transition period from GW encryption
     * keys to Azure encryption keys. Once, all users that have on encryption
     * key on GW also have an encryption key on Azure, it can safely be removed.
     * ~ summer 2026 should be safe
     *
     * @returns {Observable<boolean>} An observable that emits `true` if at least one
     * entry uses legacy encryption, otherwise `false`.
     */
    hasLegacyEncryption(): Observable<boolean>;
    /**
     * Upgrades all entries from legacy encryption to the current encryption format.
     *
     * This method performs a read-write transaction on the collection of stored entries.
     * It finds all entries whose content starts with the legacy prefix,
     * re-encrypts their content using the `encryptionMigrator`, and updates the entries
     * in the database.
     *
     * This method is only relevant for the transition period from GW encryption
     * keys to Azure encryption keys. Once, all users that have on encryption
     * key on GW also have an encryption key on Azure, it can safely be removed.
     * ~ summer 2026 should be safe
     *
     * @returns {Observable<boolean>} An observable that emits `true` once all legacy
     * encrypted entries have been successfully migrated.
     */
    upgradeEncryption(): Observable<boolean>;
}

export const OfflineStrategyInjectionToken = new InjectionToken<OfflineStrategy>('PaceOfflineStrategy');
